import {Component, OnInit} from '@angular/core';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings, Themes} from '@orga-app/settings/settings.model';
import {ActionSheetController, AlertController, LoadingController, ModalController, Platform} from '@ionic/angular';
import {Observable} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {ModalTestPage} from './modal-test/modal-test.page';
import {select, Store} from '@ngrx/store';
import {
    WsAufgabeErinnerungAction,
    WsAufgabeEskalationAction,
    WsAufgabeNichtOkAction,
    WsCommandFailedAction,
    WsCommandSucceededAction,
    WsFunktionsbereichOkAction,
    WsMitteilungAction
} from '../websocket.actions';
import {Benutzer, CommandFailedNotification, CommandSucceededNotification} from '../../clients/api';
import {
    AufgabeErinnerungNotification,
    AufgabeEskalationNotification,
    AufgabeNichtOkNotification,
    FunktionsbereichOkNotification
} from '../../clients/veranstaltungen';
import {MitteilungNotification} from '../../clients/kommunikation';
import {getUserInfo} from '@orga-app/auth/reducer';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';

declare let themesJson;
declare let document;

@Component({
    selector: 'app-komponenten',
    templateUrl: './komponenten.page.html',
    styleUrls: ['./komponenten.page.scss'],
})
export class KomponentenPage implements OnInit {
    selectedTheme: Settings;
    // themes = themesJson;
    themes$: Observable<Themes>;
    tabs: Array<{ titel: string, page: any, icon: string }> = [];
    settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    de: any;
    aiName = 'KomponentenPage';
    alive = true;
    userInfo$: Observable<Benutzer>;
    veranstaltungForm: FormGroup;

    mainView = 'default';
    aktuellerTab = 'Reiter1';
    os: string;

    constructor(
        public platform: Platform,
        private settings: SettingsProvider,
        public modalCtrl: ModalController,
        public loadingCtrl: LoadingController,
        public alertCtrl: AlertController,
        public actionsheetCtrl: ActionSheetController,
        public store: Store<any>,
        public settingsProvider: SettingsProvider,
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.themes$ = this.settings.getThemes();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        // this.settings$ = this.settingsProvider.getActiveTheme();
        this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);
        this.userInfo$ = this.store.select(getUserInfo);

        this.tabs = [
            {titel: 'Home', page: 'tab-test', icon: 'home'},
            {titel: 'Aktionen', page: 'tab-test-2', icon: 'alert'},
            {titel: 'Mitteilungen', page: 'tab-test-3', icon: 'ios-text'},
            {titel: 'Dokumente', page: 'tab-test-4', icon: 'document'},
            {titel: 'Checklisten', page: 'tab-test-5', icon: 'checkmark-circle'}
        ];

        this.de = {
            // firstDayOfWeek: 1,
            dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
            dayNamesMin: ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'],
            monthNames: ['Jannuar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            today: 'Heute',
            clear: 'Löschen'
        };
    }

    ngOnInit() {
    }

    setAppTheme(theme: Settings) {
        this.settings.setActiveTheme(theme);

        // TODO: Da Modale, Alert Fenster, Datepicker u.s.w. sich außerhalb von <ion-app> platzieren, schreibe ich die Theme Klasse hier auch in den <body>. Funktioniert zwar, aber geht technisch bestimmt eleganter!
        const classList = document.body.classList;
        const currentTheme = classList.toString().match(/\b(\w*theme-)\S*\b/g);
        if (currentTheme) {
            document.body.classList.remove(currentTheme.toString());
        }
        document.body.classList.add(theme.value);
    }

    switchMainView(view) {
        this.mainView = view;
    }

    async openModal() {
        const params = {titel: 'TEST MODAL'};
        const modal = await this.modalCtrl.create({component: ModalTestPage, componentProps: params});
        await modal.present();
    }


    async wsCommandSucceeded(userInfo: Benutzer) {
        this.store.dispatch(new WsCommandSucceededAction(<CommandSucceededNotification>{user_id: userInfo.benutzer_id}));
    }

    async wsCommandFailed(userInfo: Benutzer) {
        this.store.dispatch(new WsCommandFailedAction(<CommandFailedNotification>{user_id: userInfo.benutzer_id, error_text: 'Es ist ein WSCommandFailed gesendet worden'}));
    }

    async wsAufgabeErinnerung(userInfo: Benutzer) {
        this.store.dispatch(new WsAufgabeErinnerungAction(<AufgabeErinnerungNotification>{checkliste_titel: 'Checkliste XXX', funktionsbereich_titel: 'Funktionsbereich YYY', aufgabe_titel: 'Aufgabe ZZZ'}));
    }

    async wsAufgabeEskalation(userInfo: Benutzer) {
        this.store.dispatch(new WsAufgabeEskalationAction(<AufgabeEskalationNotification>{checkliste_titel: 'Checkliste XXX', funktionsbereich_titel: 'Funktionsbereich YYY', aufgabe_titel: 'Aufgabe WWW', eskalation_zeitpunkt_utc: new Date()}));
    }

    async wsFunktionsbereichOk(userInfo: Benutzer) {
        this.store.dispatch(new WsFunktionsbereichOkAction(<FunktionsbereichOkNotification>{titel: 'Titel YYY', funktionsbereich_titel: 'Funktionsbereich AAA', veranstaltung_titel: 'Veranstaltung BBB'}));
    }

    async wsMitteilung(userInfo: Benutzer) {
        this.store.dispatch(new WsMitteilungAction(<MitteilungNotification>{titel: 'Titel HHH', betreff: 'Betreff ...', text: 'Text ... TEXT', absender: 'Torsten Zwoch'}));
    }

    async wsAufgabeNichtOk(userInfo: Benutzer) {
        this.store.dispatch(new WsAufgabeNichtOkAction(<AufgabeNichtOkNotification>{titel: ' Titel AAA', aufgabe_titel: 'Aufagbe Titel', absender: 'Torsten Zwoch', checkliste_titel: 'Checkliste GGG', funktionsbereich_titel: 'Funktionsbereich QQQ', veranstaltung_titel: 'Veranataltung III'}));
    }

    // Loading
    async presentLoading() {
        const loader = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Bitte 3 Sekunden warten...',
            duration: 3000
        });
        await loader.present();
    }


    // Action Sheet
    async openActionSheet() {
        const actionSheet = await this.actionsheetCtrl.create({
            header: 'Albums',
            cssClass: 'action-sheets-basic-page',
            buttons: [
                {
                    text: 'Delete',
                    role: 'destructive',
                    icon: !this.platform.is('ios') ? 'trash' : null,
                    handler: () => {
                        console.log('Delete clicked');
                    }
                },
                {
                    text: 'Share',
                    icon: !this.platform.is('ios') ? 'share' : null,
                    handler: () => {
                        console.log('Share clicked');
                    }
                },
                {
                    text: 'Play',
                    icon: !this.platform.is('ios') ? 'arrow-dropright-circle' : null,
                    handler: () => {
                        console.log('Play clicked');
                    }
                },
                {
                    text: 'Favorite',
                    icon: !this.platform.is('ios') ? 'heart-outline' : null,
                    handler: () => {
                        console.log('Favorite clicked');
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel', // will always sort to be on the bottom
                    icon: !this.platform.is('ios') ? 'close' : null,
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                }
            ]
        });
        await actionSheet.present();
    }

    // Basic Alert
    async showAlert() {
        const alert = await this.alertCtrl.create({
            header: 'New Friend!',
            message: 'Your friend, Obi wan Kenobi, just approved your friend request!',
            buttons: ['Ok']
        });
        await alert.present();
    }

    // Confirm Alert
    async showConfirmAlert() {
        const confirmAlert = await this.alertCtrl.create({
            header: 'Use this lightsaber?',
            message: 'Do you agree to use this lightsaber to do good across the intergalactic galaxy?',
            buttons: [
                {
                    text: 'Disagree',
                    handler: () => {
                        console.log('Disagree clicked');
                    }
                },
                {
                    text: 'Agree',
                    handler: () => {
                        console.log('Agree clicked');
                    }
                }
            ]
        });
        await confirmAlert.present();
    }

    // Radio Alert
    async showRadioAlert() {
        const radioAlert = await this.alertCtrl.create({
            header: 'Radio Alert Box',
            message: 'Select something',
            inputs: [
                {
                    type: 'radio',
                    label: 'Something 1',
                    value: 'something1'
                },
                {
                    type: 'radio',
                    label: 'Something 2',
                    value: 'something2'
                },
                {
                    type: 'radio',
                    label: 'Something 3',
                    value: 'something3'
                },
                {
                    type: 'radio',
                    label: 'Something 4',
                    value: 'something4'
                },
                {
                    type: 'radio',
                    label: 'Something 5',
                    value: 'something5'
                }],
            buttons: [
                {
                    text: 'Cancel',
                    handler: data => {
                        console.log('cancel clicked');
                    }
                },
                {
                    text: 'Select',
                    handler: data => {
                        console.log('select clicked');
                    }
                }]
        });
        await radioAlert.present();
    }

    // Checkbox Alert
    async showCheckboxAlert() {
        const checkboxAlert = await this.alertCtrl.create({
            header: 'Checkbox Alert Box',
            message: 'Select something',
            inputs: [
                {
                    type: 'checkbox',
                    label: 'Something 1',
                    value: 'something1'
                },
                {
                    type: 'checkbox',
                    label: 'Something 2',
                    value: 'something2'
                },
                {
                    type: 'checkbox',
                    label: 'Something 3',
                    value: 'something3'
                },
                {
                    type: 'checkbox',
                    label: 'Something 4',
                    value: 'something4'
                }],
            buttons: [
                {
                    text: 'Cancel',
                    handler: data => {
                        console.log('cancel clicked');
                    }
                },
                {
                    text: 'Select',
                    handler: data => {
                        console.log('select clicked');
                    }
                }]
        });
        await checkboxAlert.present();
    }

    async showPromptAlert() {
        const promptAlert = await this.alertCtrl.create({
            header: 'Login',
            inputs: [
                {
                    name: 'username',
                    placeholder: 'Username'
                },
                {
                    name: 'password',
                    placeholder: 'Password',
                    type: 'password'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Login',
                    handler: data => {
                        console.log('Login clicked');
                    }
                }
            ]
        });
        await promptAlert.present();
    }


}
